'use client'

import * as React from 'react'
import { forwardRef, useState } from 'react'
import { EyeIcon, EyeOffIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

type PasswordInputProps = Omit<React.ComponentProps<typeof Input>, 'type'> & {
	showPasswordByDefault?: boolean
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
	({ className, showPasswordByDefault = false, ...props }, ref) => {
		const [showPassword, setShowPassword] = useState(showPasswordByDefault)

		return (
			<div className="relative">
				<Input
					type={showPassword ? 'text' : 'password'}
					className={cn('pr-10', className)}
					ref={ref}
					{...props}
				/>
				<Button
					type="button"
					variant="ghost"
					size="sm"
					className="absolute top-0 right-0 h-full px-3 py-2 hover:bg-transparent"
					onClick={() => setShowPassword(!showPassword)}
					tabIndex={-1}
				>
					{showPassword ? (
						<EyeOffIcon className="h-4 w-4" aria-hidden="true" />
					) : (
						<EyeIcon className="h-4 w-4" aria-hidden="true" />
					)}
					<span className="sr-only">{showPassword ? 'Hide password' : 'Show password'}</span>
				</Button>
			</div>
		)
	}
)
PasswordInput.displayName = 'PasswordInput'

export { PasswordInput }
